module.exports = __webpack_public_path__ + "static/media/slide_2-bg.5f5a8de4.png";